/**
 * @property PRE_ORDERING 주문 작성
 * @property REQUEST 주문 요청
 * @property STOCK_OUT 제품이 품절 처리됨
 * @property WITHDRAW_REQUEST 주문 취소 요청 중
 * @property WITHDRAW_COMPLETE 주문 취소됨
 * @property BANK_TRANSFER_WAITING 주문 취소됨
 * @property PAID 결제됨
 * @property DELIVERY_WAITING 배송 대기
 * @property DELIVERY_DELAY 배송 지연(출고 지연)
 * @property DELIVERING 배송 중
 * @property DELIVERY_END 배송 완료
 * @property INCOMPLETE 미완료됨. 어떠한 사유로 인한 상태(교환/환불 요구, 교환/환불 중 등)
 * @property COMPLETE 완료됨
 * @property UNKNOWN 미확인 상태. 주로 db migration 시 중간 상태 값으로 쓰인다.
 */
export enum OrderItemStatus {
    PRE_ORDERING = 'pre_ordering',
    REQUEST = 'request',
    STOCK_OUT = 'stock_out',
    WITHDRAW_REQUEST = 'withdraw_request',
    WITHDRAW_COMPLETE = 'withdraw_complete',
    BANK_TRANSFER_WAITING = 'bank_transfer_waiting',
    PAID = 'paid',
    DELIVERY_WAITING = 'delivery_waiting',
    DELIVERY_DELAY = 'delivery_delay',
    DELIVERING = 'delivering',
    DELIVERY_END = 'delivery_end',
    INCOMPLETE = 'incomplete',
    COMPLETE = 'complete',
    UNKNOWN = 'unknown',
}
